const MAIN_URL = 'https://george-fx.github.io/dinehub_api/';
const MAIN_URL_LOCAL = '/data/';

export const GET_MENU = `${MAIN_URL}api/menu.json`;
export const GET_DISHES = `${MAIN_URL}api/dishes.json`;
export const GET_ORDERS = `${MAIN_URL}api/orders.json`;
export const GET_REVIEWS = `${MAIN_URL}api/reviews.json`;
export const GET_BANNERS = `${MAIN_URL}api/banners.json`;
export const GET_CAROUSEL = `${MAIN_URL}api/carousel.json`;
export const GET_PROMOCODES = `${MAIN_URL}api/promocodes.json`;
export const GET_CATEGORIES = `${MAIN_URL}api/categories.json`;
export const GET_NOTIFICATIONS = `${MAIN_URL}api/notifications.json`;

export const GET_CAROUSEL_LOCAL = `${MAIN_URL_LOCAL}carousel.json`;
export const GET_SONS_LOCAL = `${MAIN_URL_LOCAL}sons.json`;
export const GET_ARTICLES_LOCAL = `${MAIN_URL_LOCAL}articles.json`;
export const GET_MENU_CAT_LOCAL = `${MAIN_URL_LOCAL}menu_cat.json`;
export const GET_FEE_CAT_LOCAL = `${MAIN_URL_LOCAL}fee_cat.json`;
export const GET_FEE_KINDS_LOCAL = `${MAIN_URL_LOCAL}fee_kinds_details.json`;
export const GET_ACTIVITIES_LOCAL = `${MAIN_URL_LOCAL}activities.json`;
export const GET_PARTNERS_LOCAL = `${MAIN_URL_LOCAL}partners.json`;
export const GET_EXTRA_CURRICULAR_LOCAL = `${MAIN_URL_LOCAL}extra_curricular.json`;
export const GET_ACADEMY_LOCAL = `${MAIN_URL_LOCAL}academy.json`;
export const GET_CREATION_LOCAL = `${MAIN_URL_LOCAL}creation.json`;
export const GET_CAMPER_VANS_LOCAL = `${MAIN_URL_LOCAL}camper_vans.json`;
export const GET_FEEDS_LOCAL = `${MAIN_URL_LOCAL}feeds.json`;
export const GET_HISTORY_LOCAL = `${MAIN_URL_LOCAL}history.json`;
export const GET_LOCATIONS_LOCAL = `${MAIN_URL_LOCAL}locations.json`;

export const URLS = {
  GET_MENU,
  GET_ORDERS,
  GET_DISHES,
  GET_BANNERS,
  GET_REVIEWS,
  GET_CAROUSEL,
  GET_PROMOCODES,
  GET_CATEGORIES,
  GET_NOTIFICATIONS,
  GET_CAROUSEL_LOCAL,
  GET_SONS_LOCAL,
  GET_ARTICLES_LOCAL,
  GET_MENU_CAT_LOCAL,
  GET_FEE_CAT_LOCAL,
  GET_FEE_KINDS_LOCAL,
  GET_ACTIVITIES_LOCAL,
  GET_PARTNERS_LOCAL,
  GET_EXTRA_CURRICULAR_LOCAL,
  GET_ACADEMY_LOCAL,
  GET_CREATION_LOCAL,
  GET_CAMPER_VANS_LOCAL,
  GET_FEEDS_LOCAL,
  GET_HISTORY_LOCAL,
  GET_LOCATIONS_LOCAL,
};
